"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var decorators_1 = require("./decorators");
/**
 * Декоратор добавляет поддержку свойства defaultValue компонентам
 * поддерживающим установку значения в stateless-манере (value + onChange).
 *
 * Свойство defaultValue необходимо для создания "неконтроллируемых" компонентов
 * @see https://facebook.github.io/react/docs/uncontrolled-components.html
 * В основном это нужно для того чтобы адекватно показать компонент в storybook.
 *
 * Нативные компоненты (input, select и т.д.) поддерживают это свойство по-умолчанию,
 * этот декоратор позволяет добавить такой функционал любому кастомному компоненту
 * реализующему интерфейс value + onChange
 * @see StatelessChangeableProps
 *
 * @param ChangeableComponent Компонент без поддержки defaultValue но с поддержкой onChange и value
 * @return Компонент с поддержкой свойства defaultValue
 */


exports.withDefaultValue = decorators_1.createDecorator(function (ChangeableComponent) {
  var _a;

  return _a =
  /** @class */
  function (_super) {
    __extends(class_1, _super);

    function class_1() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.state = {
        value: _this.props.defaultValue
      };

      _this.onChange = function (value) {
        return _this.setState({
          value: value
        });
      };

      return _this;
    }

    class_1.prototype.render = function () {
      var externalProps = this.props;
      var value = this.state.value;
      var props = externalProps.value !== undefined ? externalProps : __assign(__assign({}, externalProps), {
        value: value,
        onChange: this.onChange
      });
      return React.createElement(ChangeableComponent, __assign({}, props));
    };

    return class_1;
  }(React.Component), _a.Stateless = ChangeableComponent, _a;
});